import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { MotifButton } from '@ey-xd/motif-react';
import { subHeaderPLPastQtrDetails } from '../../../services/pursuitLeaderServices';
import { subHeaderPLPastMonthDetails } from '../../../services/pursuitLeaderServices';
import { dateFormat, structureMonth } from '../../../util/commonUtil';
import {
  QuarterTitle,
  SubHeaderContainer,
  SubmitButtonContainer,
  QuarterDates,
} from './subHeader.styles';
import { BUTTON_TITLE, abbreviatedMonthList } from '../../../constants/commonConstants';
import { useRecoilValue } from 'recoil';
import { Current_User } from '../../../recoil/recoil';

const SubHeaderPLPast = props => {
  const navigate = useNavigate();
  const [subHeaderData, setSubHeaderData] = useState([]);
  const currentUser = useRecoilValue(Current_User);

  let MONTH = props.month;
  let YEAR = props.year;
  let forecast_type = props.forecast_type;
  let QUARTER = props.quarter;
  const fetchDateRange = async () => {
    try {
      let data = await (forecast_type === 'quarter'
        ? subHeaderPLPastQtrDetails(QUARTER, YEAR, currentUser.email)
        : forecast_type === 'month'
          ? subHeaderPLPastMonthDetails(QUARTER, MONTH, YEAR, currentUser.email)
          : Promise.reject(new Error('Invalid forecast_type')));

      setSubHeaderData(data);
    } catch (error) {
      console.error('Error fetching forecast submit status:', error);
    }
  };

  useEffect(() => {
    fetchDateRange();
  }, [forecast_type, MONTH, YEAR, QUARTER]);

  const formatDate = date => {
    const month_array = abbreviatedMonthList;
    let d = new Date(date);
    let day = d.getDate();
    let month = month_array[d.getMonth()];
    let year = d.getFullYear();
    return `${month} ${day}, ${year}`;
  };
  let start_date;
  let end_date;
  if (subHeaderData.length !== 0) {
    let keys = Object.keys(subHeaderData);
    start_date = subHeaderData[keys[0]].start_date;
    end_date = subHeaderData[keys[keys.length - 1]].end_date;
    start_date = formatDate(start_date);
    end_date = formatDate(end_date);
  }

  const fullMonth = MONTH ? structureMonth(MONTH) : '';
  const quarter = QUARTER.charAt(1);
  const handlePostData = async () => {};

  const renderQuarterInfo = () => {
    if (setSubHeaderData.length !== 0) {
      return (
        <>
          {forecast_type == 'quarter' ? (
            <QuarterTitle>
              Quarter {quarter} FY {YEAR}
            </QuarterTitle>
          ) : (
            <QuarterTitle>
              {fullMonth} FY {YEAR}
            </QuarterTitle>
          )}
        </>
      );
    }
  };

  return (
    <SubHeaderContainer>
      {renderQuarterInfo()}
      <SubmitButtonContainer>
        <MotifButton
          variant="secondary"
          className="submitButton"
          onClick={() => {
            navigate('/');
          }}
        >
          {BUTTON_TITLE.CLOSE}
        </MotifButton>
      </SubmitButtonContainer>
    </SubHeaderContainer>
  );
};

export default SubHeaderPLPast;
